// extracted by mini-css-extract-plugin
export default {"control":"style_control__AQo5Z","Mini":"style_Mini__RHky8","controller":"style_controller__zIMHH"};